import React from 'react'
import PolicyPage from '../../PrivacyPolicy/PolicyPage'
import { useParams } from "react-router-dom";
import BreadCrumb from '../../BreadCrumb/BreadCrumb';


const PrivacyPolicy = () => {
    const { index, idx } = useParams();
  return (
    <>
    <div>
        <BreadCrumb paths={[{name:"Home",path:'/dashboard'},{name:"Tips",path:`/dashboard/country-shots/${index}/${idx}`},
            {name:"Privacy-Policy",path:""}
        ]}/>
    </div>
    <div style={{margin:"20px 0px"}}><PolicyPage/></div>
    
    </>
  )
}

export default PrivacyPolicy